import { Branding, BrandingDisabledIf, DisabledPrompt, NavLink, useModel, BrandingStyle } from "bcms-react";
import React, { useEffect, useState } from "react";
import BID1224MainNavItems from "./customMenuViews/BID1224MainNavItems";
import BID126MainNavItems from "./customMenuViews/BID126MainNavItems";
import { SVGAsset } from "res";
import "./mobile.css";
import "./styles.css";
import { Profile } from "model";
import MainNavCustomAccordion from "components/custom-ui/MainNavCustomAccordion";
import BID932MainNavItems from "./customMenuViews/BID932MainNavItems";
import BID2132PMainNavItems from "./customMenuViews/BID2132PMainNavItems";
import BID2132BMainNavItems from "./customMenuViews/BID2132BMainNavItems";
import BID1225BMainNavItems from "./customMenuViews/BID1225BMainNavItems";
import BID1225PMainNavItems from "./customMenuViews/BID1225PMainNavItems";

/**
 * @name MainNavView
 * @function
 * @extends React.Component
 * @exported true
 * @description The main component for navigation
 * @example
 * export default function Component() {
 *  return (
 *      <div>
 *          <MainNavView />
 *      </div>
 *  );
 * }
 */
export default function MainNavView(props) {
    const { branding, demos } = useModel();
    const { options } = branding;

    let paymentsLabel = options.payments_label_abi22.length ? options.payments_label_abi22 : "Payments";
    let creditSenseLink = options.cs21_courseID_abi22 === null ? <DisabledPrompt><MainNavMenuItem label="Credit Score" data-point="Nav_Credit_Score" /></DisabledPrompt> : <MainNavMenuItem label="Credit Score" route="/creditScore" data-point="Nav_Credit_Score" />;
    let externalTransfersLink = options.tn19_courseID_abi22 === null ? <DisabledPrompt><MainNavMenuItem label="External Transfers" data-point="Nav_External_Transfers" /></DisabledPrompt> : <MainNavMenuItem label="External Transfers" route="/externalTransfers" data-point="Nav_External_Transfers" />;
    //const openAccount = evt => window.open( demos[options.orig_version_abi22 ?? "ORIG20"], "_blank");
    const openAccount = () => {
        let origVersion = branding.options.orig_version_abi22;
        if (origVersion !== "ORIG19") origVersion = "ORIG20";
        window.open(demos[origVersion], "_blank");
    };
    const openMerchantSourceCapture = evt => window.open(demos["MSC19"], "_blank");
    let newAccountsLink = <MainNavItem label="Accounts" data-point="Nav_Accounts" activeRoutes={["/accountdetails/*", "/creditScore", "/stopPayment", "/download"]}>
        <MainNavMenuItem label="Account Summary" route="/accountSummary" data-point="Nav_Account_Summary" />
        <MainNavMenuItem label="ePreference" route="/statementPreference" data-point="Nav_ePeference" />
        <Branding id="open_account_abi22" value="true">
            <BrandingDisabledIf id="orig_courseid_abi22" exp={value => value !== null && value !== undefined}>
                <MainNavMenuItem label="Open An Account" data-point="Nav_Open_Account" onClick={openAccount} />
            </BrandingDisabledIf>
        </Branding>
        <Branding id="cs21_abi22" value="true">
            {creditSenseLink}
        </Branding>
        <Branding id="stop_payments_abi22" value="true">
            <MainNavMenuItem label="Stop Payments" route="/stopPayment" data-point="Nav_Stop_Payments" />
        </Branding>
        <Branding id="download_abi22" value="true">
            <MainNavMenuItem label="Download" route="/download" data-point="Nav_Download" />
        </Branding>
        <Branding id="statements_abi22" value="true">
            <MainNavMenuItem label="E-Statements & Notices" route="/statements" data-point="Nav_eStatements_Notices" />
        </Branding>


    </MainNavItem>;
    let accountsLink = <MainNavItem label="Accounts" data-point="Nav_Accounts" activeRoutes={["/accountdetails/*", "/creditScore", "/stopPayment", "/download"]}>
        <MainNavMenuItem label="Account Summary" route="/accountSummary" data-point="Nav_Account_Summary" />
        <MainNavMenuItem label="ePreference" route="/statementPreference" data-point="Nav_ePeference" />
        <Branding id="cs21_abi22" value="true">
            {creditSenseLink}
        </Branding>
        <Branding id="stop_payments_abi22" value="true">
            <MainNavMenuItem label="Stop Payments" route="/stopPayment" data-point="Nav_Stop_Payments" />
        </Branding>
        <Branding id="download_abi22" value="true">
            <MainNavMenuItem label="Download" route="/download" data-point="Nav_Download" />
        </Branding>
        <MainNavMenuItem label="E-Statements & Notices" route="/statements" data-point="Nav_eStatements_Notices" />
        <Branding id="open_account_abi22" value="true">
            <BrandingDisabledIf id="orig_courseid_abi22" exp={value => value !== null && value !== undefined}>
                <MainNavMenuItem label="Open An Account" data-point="Nav_Open_Account" onClick={openAccount} />
            </BrandingDisabledIf>
        </Branding>
    </MainNavItem>;
    let newTransfersLink = <MainNavItem label="Transfers" data-point="Nav_Transfers" activeRoutes={["/transferActivity/transferHistory", "/externalTransfers"]} >
        <MainNavMenuItem label="Make a Transfer" route="/transfers" data-point="Nav_Make_Transfer" />
        <Branding id="transfer_templates_abi22" value="true">
            <MainNavMenuItem label="Transfer Templates" route="/addTransferTemplateWorkflow" data-point="Nav_Transfer_Templates" />
        </Branding>
        <Branding id="tn19_abi22" value="true">
            {externalTransfersLink}
        </Branding>
        <MainNavMenuItem label="Transfer Activity" route="/transferActivity/scheduledTransfers" data-point="Nav_Transfer_Activity" />
        <Branding id="transfer_accounts_abi22" value="true">
            <MainNavMenuItem label="Transfer Accounts" route="/unlinkedTransferAccounts" data-point="Nav_Transfer_Accounts" />
        </Branding>
        <Branding id="native_external_accounts_abi22" value="true">
            <MainNavMenuItem label="Transfer Accounts" route="/transferAccounts" data-point="Nav_Transfer_External_Accounts" />
        </Branding>
    </MainNavItem>;

    // This link is only used by bid "1588".                       
    let transfersLink = <MainNavItem label="Transfers" data-point="Nav_Transfers" activeRoutes={["/transferActivity/transferHistory", "/externalTransfers"]} >
        <MainNavMenuItem label="Make a Transfer" route="/transfers" data-point="Nav_Make_Transfer" />
        <MainNavMenuItem label="Transfer Activity" route="/transferActivity/scheduledTransfers" data-point="Nav_Transfer_Activity" />
        <Branding id="tn19_abi22" value="true">
            {externalTransfersLink}
        </Branding>
        <Branding id="transfer_accounts_abi22" value="true">
            <MainNavMenuItem label="Transfer Accounts" route="/unlinkedTransferAccounts" data-point="Nav_Transfer_Accounts" />
        </Branding>
        <Branding id="native_external_accounts_abi22" value="true">
            <MainNavMenuItem label="Transfer Accounts" route="/transferAccounts" data-point="Nav_Transfer_External_Accounts" />
        </Branding>
        {/* <MainNavMenuItem label="Transfer Accounts" route="/transferAccountsWorkflow" data-point="Nav_Transfer_Activity" /> */}
    </MainNavItem>;

    let documentsLink = <MainNavItem label="Documents" data-point="Nav_Documents">
        <Branding id="statements_abi22" value="true">
            <MainNavMenuItem label="Statements" route="/statements" data-point="Nav_Statements" />
        </Branding>
        <DisabledPrompt>
            <MainNavMenuItem label="Notices" data-point="Nav_Notices" />
        </DisabledPrompt>
        <MainNavMenuItem label="Enrollment" route="/enrollment" data-point="Nav_Enrollment" />
    </MainNavItem>;

    let depositsLink = (options.deposits_abi22 == "true" || options.msc_id_abi22 == "true") ?
        <MainNavItem label="Deposits" data-point="Nav_Deposits">
            <Branding id="deposits_abi22" value="true"> <MainNavMenuItem label="Deposit History" route="/depositHistory" data-point="Nav_Deposit_History" /> </Branding>
            <Branding id="msc_abi22" value="true">
                <BrandingDisabledIf id="msc_id_abi22" exp={value => value !== null && value !== undefined}>
                    <MainNavMenuItem label="Merchant Source Capture" className="merchant-source-capture" data-point="Nav_Merchant_Source_Capture" onClick={openMerchantSourceCapture} />
                </BrandingDisabledIf>
            </Branding>
        </MainNavItem> : <DisabledPrompt><MainNavItem label="Deposits" data-point="Nav_Deposits"></MainNavItem></DisabledPrompt>;

    let achLinks = <MainNavItem label="ACH" data-point="Nav_ACH" activeRoutes={["/achParticipants", "/achTemplates", "/achActivity", "/achPassthru", "/achImport", "/stateTaxIDPage", "/denyUsers", "/nonNachaFileImportWorkflow"]} >
        <Branding id="ach_participants_abi22" value="true">
            <MainNavMenuItem label="ACH Participants" route="/achParticipants" data-point="Nav_ACH_Participants" />
        </Branding>
        <Branding id="one_time_ach_abi22" value="true">
            {/* TODO: Disabled Prompt will need removed once One-Time ACH Payment Workflow is hooked up */}           
                <MainNavMenuItem label="One-Time ACH Payment" className="one-time-ach-payment-main-nav-item" route="/oneTimeACHWorkflow" data-point="Nav_One-Time_ACH_Payments" />
        </Branding>
        <Branding id="ach_templates_abi22" value="true">
            <MainNavMenuItem label="ACH Templates" route="/achTemplates" data-point="Nav_ACH_Templates" />
        </Branding>
        <Branding id="ach_activity_abi22" value="true">
            <MainNavMenuItem label="ACH Activity" route="/achActivity" data-point="Nav_ACH_Activity" />
        </Branding>
        <Branding id="ach_pass_thru_abi22" value="true">
            <MainNavMenuItem label="ACH Pass-Thru" route="/achPassthru" data-point="Nav_ACH_Pass-Thru" />
        </Branding>
        <Branding id="import_file_flyout_abi22" value="true">
            <MainNavMenuItem label="Import File" data-point="Nav_Import">
                <Branding id="ach_import_abi22" value="true">
                    <MainNavMenuItem className="participants-and-nacha-main-nav-menu-item" label="Participants And NACHA" route="/achImport" data-point="Nav_Participants_And_NACHA" />
                </Branding>
                <Branding id="nonnacha_abi22" value="true">
                    <MainNavMenuItem label="Non-NACHA" route="/nonNachaFileImportWorkflow" data-point="Nav_Non-NACHA" />
                </Branding>
            </MainNavMenuItem>
        </Branding>
        <Branding id="import_file_flyout_abi22" value="false">
            <MainNavMenuItem label="Import" route="/achImport" data-point="Nav_Import" />
        </Branding>
        <Branding id="state_tax_ids_abi22" value="true">
            <MainNavMenuItem label="State Tax IDs" route="/stateTaxIDPage" data-point="Nav_State_Tax_IDs" />
        </Branding>
        <Branding id="deny_users_abi22" value="true">
            <MainNavMenuItem label="Deny Users" route="/denyUsers" data-point="Nav_Deny_Users" />
        </Branding>
    </MainNavItem>;

    let wireLinks = <MainNavItem label="Wires" data-point="Nav_Wires" activeRoutes={["/wireAddPayeeWorkflow","/wirePayees", "/singleWire", "/multipleWires", "/wiresActivity"]}>
        <Branding id="wire_payees_abi22" value="true">
            <MainNavMenuItem label="Wire Payees" route="/wireAddPayeeWorkflow" data-point="Nav_Wire_Payees"  />
        </Branding>
        <Branding id="single_wire_abi22" value="true">
            <MainNavMenuItem label="Single Wire" route="/singleWire" data-point="Nav_Single_Wire" />
        </Branding>
        <Branding id="multiple_wires_abi22" value="true">
            <MainNavMenuItem label="Multiple Wires" route="/multipleWires" data-point="Nav_Multiple_Wires" />
        </Branding>
        <Branding id="onetime_wire_abi22" value="true">
            <MainNavMenuItem label="One-Time Wire" route="/oneTimeWireTransferWorkflow" data-point="Nav_One_Time_Wire" />
        </Branding>
        <Branding id="wire_activity_abi22" value="true">
            <MainNavMenuItem label="Wire Activity" route="/wiresActivity" data-point="Nav_Wire_Activity" />
        </Branding>
    </MainNavItem>

    let paymentLink = options.rxp17_courseID_abi22 === null ? <DisabledPrompt><MainNavItem label={paymentsLabel} data-point="Nav_Payments" /></DisabledPrompt> : <MainNavItem label={options.payments_label_abi22 ?? "paymentsLabel"} route="/payments" data-point="Nav_Payments" />;
    let pfmLink = options.pfm21_courseID_abi22 === null ? <DisabledPrompt><MainNavItem label="My Finances" data-point="Nav_My_Finances" /></DisabledPrompt> : <MainNavItem label="My Finances" route="/myFinances" data-point="Nav_My_Finances" />;

    const hasMultiProfileOptionOn = options.multiprofile_abi22 === "true";
    let changeProfilePath = `/changeProfile`;

    // Use a try/catch here since this component is shared and 
    // "initAll" is not accessible in some of the login pages.
    try {
        const zelleProfile = Profile.initAll()[0];
        const zelleProfileID = zelleProfile.id;
        const defaultZelleProfileType = zelleProfile.type.toLowerCase();
        changeProfilePath = `/changeProfile/${defaultZelleProfileType}/${zelleProfileID}`;
    } catch { }

    const zleMainNavItem = <MainNavItem label={<>Zelle<span className="r-mark">&reg;</span></>} route={hasMultiProfileOptionOn ? changeProfilePath : "/zelle"} data-point="Nav_Zelle" />;

    let zleLinkEnabled = options.zle_courseID_abi22 === null ? false : true;

    // If option "How is Zelle presented?" is set to "CheckFree", 
    // but a "CheckFree" course id is not set, disable the "Zelle" link.
    if (options.present_zelle_abi22 === "CheckFree" && options.rxp17_courseID_abi22 === null) {
        zleLinkEnabled = false;
    }

    const zleLink = zleLinkEnabled
        ? zleMainNavItem
        : <DisabledPrompt>{zleMainNavItem}</DisabledPrompt>;

    const showStandardMenu = val => (
        val !== "123" &&
        val !== "1588" &&
        val !== "1224" &&
        val !== "126" &&
        val !== "932" &&
        val !== "2132P" &&
        val !== "2132B" &&
        val !== "1225B" &&
        val !== "1225P"
    );

    return (
        <BrandingStyle style={{
            "backgroundColor": "navigation_bar_bg_abi22"
        }} className="main-nav">
            <Branding id="bid_abi22" value="Standard" exp={showStandardMenu} >
                <div className="flex-container flex-horizontal">
                    {newAccountsLink}
                    {newTransfersLink}
                    <Branding id="rxp17_abi22" value="true">
                        {paymentLink}
                    </Branding>
                    <Branding id="zle_abi22" value="true">
                        {zleLink}
                    </Branding>
                    <Branding id="cards_abi22" value="true">
                        <BrandingDisabledIf id="chw23_courseid_abi22" exp={value => value !== null && value !== undefined}>
                            <MainNavItem label="Cards" route="/chw23" data-point="Nav_Cards" />
                        </BrandingDisabledIf>
                    </Branding>
                    <Branding id="pfm21_abi22" value="true">
                        {pfmLink}
                    </Branding>
                    {/*removed for now till we verify from fiserv */}
                    <Branding id="documents_abi22" value="true">
                        {/*documentsLink*/}
                    </Branding>
                    <Branding id="deposits_nav_abi22" value="true">
                        {/* "depositsLink" was removed due to needing to verify
                    with fiserv (as noted in the comment above),
                    but is now temporarily added so that we can work
                    on "Deposits" pages that need to be supported. */}
                        {depositsLink}
                    </Branding>
                    <Branding id="ach_abi22" value="true">
                            {achLinks}
                    </Branding>
                    <Branding id="wires_abi22" value="true">
                        {wireLinks}
                    </Branding>
                </div>
            </Branding>

            {/* Using bid specific component to reduce the amount of code used in this file. */}
            <BID126MainNavItems />
            <BID1224MainNavItems />
            <BID932MainNavItems />
            <BID2132PMainNavItems />
            <BID2132BMainNavItems />
            <BID1225BMainNavItems />
            <BID1225PMainNavItems />

            <Branding id="bid_abi22" value="123" >
                <div className="flex-container flex-horizontal">
                    {accountsLink}
                    <Branding id="rxp17_abi22" value="true">
                        {paymentLink}
                    </Branding>
                    <Branding id="zle_abi22" value="true">
                        {zleLink}
                    </Branding>
                    <MainNavItem label="Transfers" data-point="Nav_Transfers" activeRoutes={["/transferActivity/transferHistory"]} >
                        <MainNavMenuItem label="Make a Transfer" route="/transfers" data-point="Nav_Make_Transfer" />
                        <Branding id="tn19_abi22" value="true">
                            {externalTransfersLink}
                        </Branding>
                        <MainNavMenuItem label="Transfer Activity" route="/transferActivity/scheduledTransfers" data-point="Nav_Transfer_Activity" />
                        <Branding id="transfer_accounts_abi22" value="true">
                            <MainNavMenuItem label="Transfer Accounts" route="/unlinkedTransferAccounts" data-point="Nav_Transfer_Accounts" />
                        </Branding>
                        <Branding id="native_external_accounts_abi22" value="true">
                            <MainNavMenuItem label="Transfer Accounts" route="/transferAccounts" data-point="Nav_Transfer_External_Accounts" />
                        </Branding>
                    </MainNavItem>
                    <Branding id="cards_abi22" value="true">
                        <BrandingDisabledIf id="chw23_courseid_abi22" exp={value => value !== null && value !== undefined}>
                            <MainNavItem label="Cards" route="/chw23" data-point="Nav_Cards" />
                        </BrandingDisabledIf>
                    </Branding>
                    <Branding id="pfm21_abi22" value="true">
                        {pfmLink}
                    </Branding>
                    {/*removed for now till we verify from fiserv */}
                    <Branding id="documents_abi22" value="true">
                        {/*documentsLink*/}
                    </Branding>
                    <Branding id="deposits_nav_abi22" value="true">
                        {/*depositsLink*/}
                    </Branding>
                </div>
            </Branding>

            <Branding id="bid_abi22" value="1588"  >
                <div className="flex-container flex-horizontal">
                    {accountsLink}
                    <Branding id="rxp17_abi22" value="true">
                        {paymentLink}
                    </Branding>
                    <Branding id="cards_abi22" value="true">
                        <BrandingDisabledIf id="chw23_courseid_abi22" exp={value => value !== null && value !== undefined}>
                            <MainNavItem label="Cards" route="/chw23" data-point="Nav_Cards" />
                        </BrandingDisabledIf>
                    </Branding>
                    <Branding id="zle_abi22" value="true">
                        {zleLink}
                    </Branding>
                    {transfersLink}

                    <Branding id="pfm21_abi22" value="true">
                        {pfmLink}
                    </Branding>
                    {/*removed for now till we verify from fiserv */}
                    <Branding id="documents_abi22" value="true">
                        {/*documentsLink*/}
                    </Branding>
                    <Branding id="deposits_nav_abi22" value="true">
                        {/*depositsLink*/}
                    </Branding>
                </div>
            </Branding>
        </BrandingStyle>
    );
}

/**
 * @name MainNavItem
 * @function
 * @extends React.Component
 * @exported false
 * @description Main nav item in the *MainNavView* component
 * @param {STRING} label - Text of the the link
 * @param {STRING} route - The route that should occur on click
 * @param {STRING} data-point - The data point that should be added to the MainNavItem
 * @param {React.Component} children - Any child elements
 * @note </br>
 *  - If child elements exist
 *      - The route will be overwritten and only show a dropdown on click
 *      - The link will appear active for all of the child routes
 * @example
 * <MainNavItem label="Link A" route="/Link" />
 * 
 * <MainNavItem label="Link B">
 *  <MainNavMenuItem label="Sub Link A" route="/Path" />
 * </MainNavItem>
 */
export function MainNavItem(props) {
    const point = props["data-point"] ? props["data-point"] : props.dataPoint ?? "";
    const additionalRoutes = props.activeRoutes ?? [];

    const [dropdown, setDropdown] = useState(false);
    const toggleDropdown = () => {
        setDropdown(!dropdown)
    };

    const hasChildren = React.Children.count(props.children) > 0;
    let activeRoutes = hasChildren
        ? React.Children.map(props.children, item => {
            if (React.isValidElement(item) && item.props.route !== undefined) {
                return item.props.route;
            }
        }, [])
        : [props.route ?? ""];

    activeRoutes = activeRoutes.concat(additionalRoutes);

    const handleOnClick = evt => {
        if (props.onClick instanceof Function) {
            props.onClick();
        }
    }

    return (
        <div className="main-nav-item-view" data-point={point}>
            <NavLink
                className="main-nav-item"
                to={!hasChildren && props.route}
                activeRoutes={activeRoutes}
                activeClassName="active-item"
                onClick={hasChildren ? toggleDropdown : handleOnClick}>
                <span>{props.label}</span>
                {hasChildren && <SVGAsset id="DownChevronIcon" />}
            </NavLink>

            {dropdown &&
                <div>
                    <BrandingStyle style={{
                        "backgroundColor": "sub_nav_bg_abi22",
                        "borderColor": "sub_nav_bg_abi22"
                    }} className="main-nav-dropdown flex-container flex-vertical" >
                        <div className="">
                            {React.Children.map(props.children, child => React.cloneElement(child, { onClick: () => setDropdown(false) }))}
                        </div>
                    </BrandingStyle>


                    <div className="main-nav-overlay" onClick={() => setDropdown(!dropdown)}></div>
                </div>}
        </div>
    );
}

/**
 * @name MainNavMenuItem
 * @function
 * @extends React.Component
 * @exported false
 * @description Child nav item of the *MainNavItem* component
 * @param {STRING} label - Text of the link
 * @param {STRING} route - The route that should occur on click
 * @param {STRING} data-point - The point that should be added to the MainNavMenuItem
 * @example
 * <MainNavItem label="Link B">
 *  <MainNavMenuItem label="Sub Link A" route="/Path" />
 * </MainNavItem>
 */
export function MainNavMenuItem(props) {
    const point = props["data-point"] ? props["data-point"] : props.dataPoint ?? "";
    const className = props.className ?? "";
    const hasChildren = props.children ? true : false;

    return (
        <>
            {!hasChildren &&
                <NavLink to={props.route} onClick={props.onClick}>
                    <div className={className + " main-nav-menu-item-view"} data-point={point}>
                        <span className="main-nav-menu-item-view-label">{props.label}</span>
                    </div>
                </NavLink>
            }
            {hasChildren &&
                <>
                    <div className="utility-nav-menu-item clickable utility-nav-menu-accordion flyout-nav-menu-container" data-point={point}>
                        <MainNavCustomAccordion className="menu-nav-item-accordion" activeClass="sub-nav-open" dataPoint={point} label={props.label}>
                            {props.children}
                        </MainNavCustomAccordion>
                    </div>
                </>
            }
        </>
    );
}